import { OPPORTUNITY_TYPES } from '@joc/api-gateway';
import { OpportunityInitialValuesType } from 'core/types/OPPORTUNITIES';

export const OPPORTUNITY_INITIAL_VALUES: OpportunityInitialValuesType = {
	opportunityName: '',
	opportunityDescription: '',
	isApprovalRequired: null,
	startDay: null,
	endDay: null,
	startTime: '',
	endTime: '',
	user: null,
	withWho: [],
	opportunityTypes: null,
	organisationId: '',
	address: null,
};
export const OPPORTUNITIES_INITIAL_VALUES_MANUAL: OpportunityInitialValuesType = {
	opportunityName: '',
	opportunityDescription: '',
	isApprovalRequired: false,
	startDay: null,
	endDay: null,
	startTime: '',
	endTime: '',
	user: null,
	withWho: [],
	opportunityTypes: OPPORTUNITY_TYPES.MANUAL,
	organisationId: '',
	address: null,
};
export const OPPOTUNITIES_FULL_TEXT_SEARCH_FIELDS = [
	'opportunityName',
	'startTime',
	'endTime',
	'opportunityDescription',
	'user',
	'location',
];

export enum OPPORTUNITIES_TABS {
	ALL = 'ALL',
	STAGED = 'STAGED',
	UPCOMING = 'UPCOMING',
	PENDING = 'PENDING',
	VACANCIES = 'VACANCIES',
	MANUAL = 'MANUAL',
	PAST = 'PAST',
	REJECTED = 'REJECTED',
}
